import LliamClient from '@locuslabs/lliam-client';
import * as Request from '../request';
import * as Config from '../config';

const lliamClient = async (stage = Config.getStage()) => {
    const accessToken = await Config.getAccessToken();
    return LliamClient(accessToken, stage);
};

const getDerivedPolicyForTokenRequest = Request.makeRequest(lliamClient, 'getDerivedPolicyForToken');

const Lliam = { getDerivedPolicyForToken: () => getDerivedPolicyForTokenRequest() };

export { Lliam };
